import { render, staticRenderFns } from "./Chartrelevance.vue?vue&type=template&id=275481c1&scoped=true&"
import script from "./Chartrelevance.vue?vue&type=script&lang=js&"
export * from "./Chartrelevance.vue?vue&type=script&lang=js&"
import style0 from "./Chartrelevance.vue?vue&type=style&index=0&id=275481c1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275481c1",
  null
  
)

export default component.exports